"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledAccountTitle_1 = require("./StyledAccountTitle");
const StyledAvatar_1 = require("./StyledAvatar");
const StyledAvatarLetter_1 = require("./StyledAvatarLetter");
const StyledNamesContainer_1 = require("./StyledNamesContainer");
const StyledSmallFont_1 = require("../styles/fonts/StyledSmallFont");
const Account = (props) => {
    return (react_1.default.createElement("div", { className: 'row align-items-center' },
        react_1.default.createElement("div", { className: 'col-auto' },
            react_1.default.createElement(StyledAvatar_1.StyledAvatar, null,
                react_1.default.createElement(StyledAvatarLetter_1.StyledAvatarLetter, null, props.accountName.charAt(0)))),
        react_1.default.createElement(StyledNamesContainer_1.StyledNamesContainer, { className: 'col ml-n2' },
            react_1.default.createElement(StyledAccountTitle_1.StyledAccountTitle, { className: 'mb-1 account-name' }, props.accountName),
            react_1.default.createElement(StyledSmallFont_1.StyledSmallFont, { className: 'small mb-0' }, props.userName))));
};
Account.propTypes = {
    accountName: prop_types_1.default.string,
    userName: prop_types_1.default.string
};
exports.default = Account;
